"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.EmailCanvasConverterTab = ({ isActive, idxPath, dispatchCanvasAction, activeIsSet, activeConversionBlockIdx, finished, conversionStatus, displayName, }) => {
    return (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "EmailCanvasConverterPanel.Toolbar.tab", color: "link", onClick: () => {
            dispatchCanvasAction({
                data: {
                    activeConversionBlockIdx: isActive ? null : idxPath,
                },
                type: 'state',
            });
        }, flexColCenteredFilled: true, style: {
            opacity: activeIsSet && !isActive ? 0.5 : undefined,
            whiteSpace: 'nowrap',
        }, className: {
            'border-right small px-2 cursor-pointer': true,
            'hover-underline': !isActive,
            'text-danger': conversionStatus.error,
            'text-muted': !finished && activeConversionBlockIdx !== idxPath,
            'text-success': conversionStatus.success,
            'text-underline ': isActive,
        } },
        react_1.default.createElement(react_2.OsmosysDiv, { className: "d-block" },
            react_1.default.createElement(react_2.OsmosysIcon, { osysIcon: conversionStatus.stopped
                    ? 'pause'
                    : conversionStatus.loading
                        ? 'spinner'
                        : conversionStatus.error
                            ? 'exclamation'
                            : conversionStatus.success
                                ? 'success'
                                : 'convert', spin: conversionStatus.loading, marginRight: 2 }),
            conversionStatus.loading
                ? 'Converting'
                : conversionStatus.error
                    ? 'Failed to convert'
                    : conversionStatus.success
                        ? 'Converted'
                        : 'Conversion for',
            ' ',
            displayName)));
};
//# sourceMappingURL=ConverterTab.js.map